import React from "react";
import Global from "../Global/Global";

const FeatureSection = ({ id, data }) => {
    const {urls} = Global();
  const cards = [1, 2];

  return (
    <div
      className="feature_section"
      id={`id${id}`}
      style={{ backgroundImage: `url(${data?.bgImgold})` }}
    >
      <div className="width90 maxWidth700 floatCenter textCenter">
        <p className="mainHeading">{data?.mainHeading}</p>
        <p className="subPara">{data?.subPara}</p>

        <div className="mainContent relative">
          {/* Center Image */}
          <div className="imgSec">
            <img
              className="cover"
              src={urls.assets + data?.centerImgold}
              alt={data?.imgAlt}
            />
          </div>

          {/* Card 1 & 2 */}
          {cards.map((i) =>
            data?.[`cardHead${i}`] ? (
              <div
                key={i}
                className={`textBox textCenter absolute box${i}`}
              >
                <p className="cardHead">{data?.[`cardHead${i}`]}</p>
                <p className="cardPara">{data?.[`cardPara${i}`]}</p>

                <div className="indicatorSec flex alignCenter justifyCenter flexColumn">
                  <div className="indicator"></div>
                  <div className="plusIcon flex alignCenter justifyCenter">
                    <i className="fa-solid fa-plus"></i>
                  </div>
                </div>
              </div>
            ) : null
          )}

          {/* Card 3 */}
          {data?.cardHead3 && (
            <div className="textBox textCenter absolute box3">
              <div className="indicatorSec flex alignCenter justifyCenter flexColumn">
                <div className="plusIcon flex alignCenter justifyCenter">
                  <i className="fa-solid fa-plus"></i>
                </div>
                <div className="indicator"></div>
              </div>

              <p className="cardHead">{data?.cardHead3}</p>
              <p className="cardPara">{data?.cardPara3}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeatureSection;